<template>
    <CContainer>
        <CRow alignHorizontal="end">
            <CCol :sm="2">
                <CDropdown
                    class="modal_editor__dropdown"
                    color="primary"
                    toggler-text="" 
                    :style="{
                        float:'right',
                    }"
                    size="sm"
                >
                    <CDropdownItem @click="addOption()">Add option</CDropdownItem>
                </CDropdown>
            </CCol>
        </CRow>
        <CRow>
            <CCol sm="12">
                <CTabs :active-tab="0" @update:activeTab="refreshTab">
                    <!-- Tab options -->
                    <CTab title="Options">
                        <CCard class="gjs-mdl-card">
                            <CCardBody>
                                <CContainer fluid>
                                    <CRow>
                                        <CCol sm="12">
                                            <CInput
                                                :value.sync="form.question_text"
                                                placeholder="What is your question?"
                                            />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol sm="12"><p>Configure your options:</p></CCol>
                                        <CCol sm="12" style="position:relative; overflow-y:auto; max-height:270px">

                                            <CInput
                                                v-for="(option,index) in form.options" :key="index" class="mb-3"
                                                :value.sync="option.label"
                                                :isValid="validateState('options','label',index)"
                                                invalidFeedback="This is a required field"
                                            >
                                                <template #append>
                                                    <CButton class="btn-control-options" color="light" v-if="form.options.length-1 == index" @click="addOption()">
                                                        <CIcon
                                                            class="icon"
                                                            :content="$options.icons.cilPlus"
                                                        />
                                                    </CButton>
                                                    <CButton class="btn-control-options" color="light" v-if="hasCoregistros(option)" @click="showTabCoregistro()">
                                                        <CIcon
                                                            class="icon"
                                                            :content="$options.icons.cilSettings"
                                                        />
                                                    </CButton>
                                                    <CButton class="btn-control-options" color="light" @click="deleteOption(index)">
                                                        <CIcon
                                                            class="icon"
                                                            :content="$options.icons.cilTrash"
                                                        />
                                                    </CButton>
                                                </template>
                                            </CInput>
                                        </CCol>
                                    </CRow>
                                </CContainer>

                            </CCardBody>
                            
                        </CCard>  
                    </CTab>
                    <CTab title="Settings">
                        <CCard class="gjs-mdl-card">
                            <CCardBody>
                                <CContainer fluid>
                                    <CSelect 
                                        :value.sync="format"
                                        label="Format" 
                                        horizontal
                                        :options="[
                                            {
                                                label:'Radio',
                                                value:'radio'
                                            },
                                            {
                                                label:'Select',
                                                value:'select'
                                            }
                                        ]"
                                    >
                                    </CSelect>
                                    <CRow>
                                        <CCol sm="3">
                                            <label>
                                                Require
                                            </label>
                                        </CCol> 
                                        <CCol sm="9">
                                            <CInputCheckbox
                                                :checked.sync="required"
                                            />
                                        </CCol>  
                                    </CRow>
                                </CContainer>
                            </CCardBody>
                        </CCard>
                        
                    </CTab>
                    <CTab title="Coregistros">
                        <CContainer fluid>
                            <CRow>
                                <CCol><h4 class="text-center my-3">Coregistros</h4></CCol>
                            </CRow>
                            <CRow>
                                <CCol>
                                    <div 
                                        class="input-group mb-3" 
                                        :style="{
                                            'justify-content': 'center'
                                        }"
                                    >
                                        <CSelect 
                                            :value.sync="form_coregistro.question_option" 
                                            :options="formatOptionsToSelect(form.options)" 
                                            :isValid="validateFormCoregistro('question_option')"
                                            @change="updateOptionCoregistro"
                                            placeholder="-- Please select an option --"
                                            class="m-0"
                                            :style="{
                                                width:'45%'
                                            }"
                                        >
                                        </CSelect>
                                        <div 
                                            class="input-group-separator"
                                            :style="{
                                                width:'10%'
                                            }"
                                        >
                                            <CIcon
                                                class="icon"
                                                :content="$options.icons.cilTrash"
                                            />
                                        </div>
                                        <SelectAsyncAdvance
                                            :isValid="validateFormCoregistro('question_option')"
                                            :value.sync="form_coregistro.client" 
                                            placeholder="-- Please select an option --"
                                            :optionsValue="'campaign_uid'"
                                            :optionsLabel="'campaign_name'"
                                            :endpoint="'/campaigns.api/coregisterList'" 
                                            class="m-0"
                                            :style="{
                                                width:'45%'
                                            }"
                                        />
                                    </div>
                                </CCol>
                                
                            </CRow>
                            <CRow>
                                <CCol md="7">
                                    <CSelect 
                                        label="Confirmation type:"
                                        placeholder="-- Please select an confirmation --" 
                                        class="mb-3"
                                        :value.sync="form_coregistro.confirmation_type"
                                        :options="confirmation_options"
                                        :isValid="validateFormCoregistro('confirmation_type')"
                                    >
                                    </CSelect>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol cols="4" class="d-flex align-items-end">
                                    <CInputCheckbox 
                                        class="mb-3" 
                                        :checked.sync="form_coregistro.required_acceptance" 
                                        :state="validateFormCoregistro('required_acceptance')"
                                        label="Required acceptance"
                                    >
                                    </CInputCheckbox>
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol cols="3" class="d-flex align-items-end justify-content-end">
                                    <CButton
                                        color="light"
                                        class="mb-3"
                                        @click="resetFormCoregistro"
                                    >
                                        Clean coregistro
                                    </CButton>
                                </CCol>
                            </CRow>
                        </CContainer>
                    </CTab>

                </CTabs>
            </CCol>
        </CRow>
        <CRow alignHorizontal="end">
            <CCol sm="3">
                <CButton 
                    :style="{
                        float:'right',
                    }" 
                    color="light"
                    class="ml-3"
                    @click="saveChanges()"
                >
                    Save
                </CButton>

                <CButton 
                    :style="{
                        float:'right',
                    }" 
                    color="light"
                    @click="closeModal()"
                >
                    Close
                </CButton>
                
            </CCol>
        </CRow>
        
    </CContainer>
</template>

<script>
import { generateUUID, stringToHTML } from '~/plugins/grapesjs/helper';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { cilPlus, cilSettings, cilCopy, cilTrash} from "@coreui/icons";
import SelectAsyncAdvance from "£lement/SelectAsyncAdvance";
/* import Multiselect from 'vue-multiselect'; */
const TAB_OPTIONS = 0;
const TAB_ATTRIBUTES = 1;
const TAB_COREGISTRO = 2;
const TAB_COREGISTROS = 3;

export default {
    name:"ModalQuestionOptionsrEditor",
    mixins: [validationMixin],
    icons: {
        cilPlus,
        cilSettings,
        cilCopy,
        cilTrash
    },
    components:{
        SelectAsyncAdvance,
    },
    data() {
        return {
            form:{
                question_text:null,
                options:[],
            },
            form_coregistro:{
                question_option:null,
                client:null,
                confirmation_type:null,
                required_acceptance:false,
            },
            format:null,
            id:null,
            name:null,
            required:null,
            tables:{
                coregistros:{
                    items:[],
                    fields:[
                        {
                            key:'question_option',
                            label:"Option",
                        },
                        {
                            key:'client',
                            label:"Client",
                        },
                        {
                            key:'confirmation_type',
                            label:"Confirmation"
                        },
                        {
                            key:'required_acceptance',
                            label:"Acceptance"
                        },
                        {
                            key:'options',
                            label:"Options",
                            thStyle:"width:15%"
                        }
                    ]
                }
            },
            clients:[],
            confirmation_options:[
                {
                    label:"None",
                    value:"none"
                },
                {
                    label:"Email",
                    value:"email"
                },
                {
                    label:"Phone",
                    value:"phone"
                },
                {
                    label:"Password",
                    value:"password"
                },
            ],
            coregistro:{
                question_option:null,
                client:null,
                confirmation_type:null,
                required_acceptance:false
            },
            existing_coregistro:false,
            tab_index:TAB_OPTIONS,
            no_reset_form: false,
        }
    },
    props:{
        editor:{
            required:true
        },
        opts:{
            required:true
        },
        payload:{
            required:true
        }
    },
    validations: {
        form:{
            question_text: {
                required,
            },
            options:{
                $each: {
                    label: {
                        required
                    },   
                }
            }

        },
        form_coregistro:{
            question_option:{

            },
            client:{
                required
            },
            confirmation_type:{
                required
            },
            confirmation_type_placeholder:{

            },
            required_acceptance:{

            },
            link_acceptance_conditions:{

            }
        },
        coregistro:{
            question_option:{
                required
            },
            client:{
                required
            },
            confirmation_type:{
                required
            },
            required_acceptance:{

            }
        }
    },
    methods:{
        loadData(){
            this.form.options = this.payload.options;
            this.form.question_text = this.payload.question_text;
            this.format = this.payload.attributes.format;
            this.id = this.payload.attributes.id;
            this.name = this.payload.attributes.name;
            this.loadFormCoregistro();
            
        },
        loadDefaultFormCoregistro(){
            this.form_coregistro = {
                question_option: null,
                client: null,
                confirmation_type:null,
                required_acceptance:false
            };
        },       
        loadCoregistros(){
            this.tables.coregistros.items = [];
            let options_with_coregistros = this.form.options.filter((item)=>{
                return item.coregistros && item.coregistros.length > 0;
            });
            for (let i = 0; i < options_with_coregistros.length; i++) {
                const option = options_with_coregistros[i];
                for (let j = 0; j < option.coregistros.length; j++) {
                    const coregistro = option.coregistros[j];
                    this.tables.coregistros.items.push({
                        question_option:{
                            text:option.label,
                            value:option.key,
                        },
                        ...coregistro
                    });
                    
                }
            }
        },
        loadFormCoregistro(){
            let option = this.form.options.find((item)=>{
                return item.coregistros && item.coregistros.length > 0;
            });
            if(option){
                this.form_coregistro = {
                    question_option:option.key,
                    client:option.coregistros[0].client,
                    confirmation_type:option.coregistros[0].confirmation_type,
                    required_acceptance:option.coregistros[0].required_acceptance
                } 
            }else{
                this.loadDefaultFormCoregistro();
            }
        },
        async loadClients(){
            return fetch(`${this.opts.host_api}/outgoing.api/coregisterList`, {
                method: 'GET', // *GET, POST, PUT, DELETE, etc.
                mode: 'cors', // no-cors, *cors, same-origin
                cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
                headers: {
                    ...this.opts.header
                },
            }).then((response)=>{
                response.json().then((data)=>{
                    this.clients =  data.items.map((item)=>{
                        return {
                            text:item.name,
                            value:item.campaign_id
                        }
                    });
                });
            }).catch(function (error) {
                console.error(error);
            });
            
            //return response.json(); // parses JSON response into native JavaScript objects
        },
        validateState(name,field_name = null,index = null) {
            let field = null;
            if(index == null || !field_name){
                field = this.$v.form[name];
            }else{
                field = this.$v.form[name].$each.$iter[index][field_name];
            }
            let { $dirty, $error } = field;
            return $dirty ? !$error : null;
        },
        validateFormCoregistro(name){
            let field = this.$v.form_coregistro[name];
            let { $dirty, $error } = field;
            return $dirty ? !$error : null;
        },
        validateOption(fieldName,index) {
            const field = this.$v.form.integration.items.$each.$iter[index][fieldName];
            if (!field.$dirty) {
                return null
            } 
            return !(field.$invalid || field.$model === '')
        },
        validateCoregistro(name) {
            const { $dirty, $error } = this.$v.coregistro[name];
            return $dirty ? !$error : null;
        },
        filterByCoregistro(data,filter){
            if(!filter.client && !filter.question_option){
                return true;
            }else{
                if(!filter.client && (filter.question_option == data.question_option.value)){
                    return true;
                }
                if((filter.client == data.client.value) && !filter.question_option){
                    return true;
                }
                if((filter.client == data.client.value) && (filter.question_option == data.question_option.value)){
                    return true;
                }
                return false;
            }
            
        },
        createCoregistro(index){
            this.coregistro.question_option = this.form.options[index].key;
            this.no_reset_form = true;
            this.tab_index = TAB_COREGISTRO;
        },
        showTabCoregistro(){
            this.tab_index = TAB_COREGISTRO;
        },
        hasCoregistros(option){
            return (option.coregistros.length > 0) ? true:false;
        },
        isCoregistroExisting(){
            let find_coregistro = this.tables.coregistros.items.find((item)=>{
                return this.coregistro.question_option == item.question_option.value && this.coregistro.client == item.client.value;
            });
            if(find_coregistro){
                this.coregistro.confirmation_type = find_coregistro.confirmation_type;
                this.coregistro.required_acceptance = find_coregistro.required_acceptance;
                
            }
            this.existing_coregistro = (find_coregistro)? true:false;
        },

        updateOptionCoregistro(){
            let index_option_coregistro = this.form.options.findIndex((item)=>{
                return item.coregistros.length > 0;
            });
            if(index_option_coregistro >= 0){
                this.form.options[index_option_coregistro].coregistros = [];
            }
            index_option_coregistro = this.form.options.findIndex((item) => {
                return item.key == this.form_coregistro.question_option;
            });

            if(index_option_coregistro >= 0){
                this.form.options[index_option_coregistro].coregistros = [{
                    ...this.form_coregistro
                }];
            }
            
        },

        
        resetFormCoregistro() {
            this.loadDefaultFormCoregistro();
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        refreshTab(newValue){
            if(newValue == TAB_COREGISTROS && !this.no_reset_form ){
                this.resetFormCoregistro();
            }

            if(this.no_reset_form){
                this.no_reset_form = false;
            }
        },
        addOption:function() {
            let option = {
                key:generateUUID(),
                label:"",
                value:null,
                coregistros:[]
            }
            this.form.options.push(option);
        },
        deleteOption:function(index){
            if(this.form.options.length > 1)
                this.form.options = this.form.options.filter((value,i)=> i != index );
            
        },
        formatOptionsToSelect(options){
            return options.map((option)=>{
                return {
                    label:stringToHTML(option.label).innerText.trim(),
                    value:option.key
                }
            });
        },
        addCoregistro(){
            this.$v.coregistro.$touch();
            if (this.$v.coregistro.$anyError) {
                return;
            }

            let find_client = this.clients.find((item)=>{
                return item.value == this.coregistro.client;
            });

            for (let i = 0; i < this.form.options.length; i++) {
                const option = this.form.options[i];
                if(option.key == this.coregistro.question_option){
                    let find_coregistro_index = option.coregistros.findIndex((item)=>{
                        return item.client.value == this.coregistro.client
                    })
                    if(find_coregistro_index == -1){
                        this.form.options[i].coregistros.push({
                            client:find_client,
                            confirmation_type:this.coregistro.confirmation_type,
                            required_acceptance:this.coregistro.required_acceptance
                        });
                    }else{
                        this.form.options[i].coregistros[find_coregistro_index]= {
                            client:find_client,
                            confirmation_type:this.coregistro.confirmation_type,
                            required_acceptance:this.coregistro.required_acceptance
                        }
                    }
                    
                    this.loadCoregistros();
                    break;
                }
            }
            
            this.resetFormCoregistro();
            
        },
        updateCoregistro(data){
            this.coregistro.question_option = data.item.question_option.value;
            this.coregistro.client = data.item.client.value;
            this.coregistro.confirmation_type = data.item.confirmation_type;
            this.coregistro.required_acceptance = data.item.required_acceptance;
        },
        removeCoregistro(data){
            for (let i = 0; i < this.form.options.length; i++) {
                const option = this.form.options[i];
                if(option.key == data.item.question_option.value){
                    this.form.options[i].coregistros = this.form.options[i].coregistros.splice(i,1);
                    this.loadCoregistros();
                    break;
                }
            }
        },
        closeModal(){
            this.editor.Modal.close();
        },
        saveChanges(){
            this.$v.form.$touch();
            this.$v.form_coregistro.$touch();
            if (this.$v.form.$anyError || (this.$v.form_coregistro.$anyError && this.form_coregistro.question_option != null)) {
                return;
            }

            this.updateOptionCoregistro();
            this.editor.runCommand('update-model-question-options', {
                component:this.payload.component,
                options:this.form.options,
                format:this.format,
                question_text:this.form.question_text,
                name:this.name,
                id:this.id,
                required:this.required

            });
            this.closeModal();
        }
    },
    mounted(){
        this.loadData();
        let new_options = [];
        for (let i = 0; i < this.form.options.length; i++) {
            const option = this.form.options[i];
            
            if(!option.label || option.label != ""){
                new_options.push(option);
            }
        }
        this.form.options = new_options;
    }
}
</script>

<style lang="scss">
    .dropdown-toggle-no-caret{
        &::after{
            display: none;
        }
    }
    .absolute-top-right{
        position: absolute;
        top: 0%;
        right: 2%;
        z-index: 1200;
    }
    .b-dropdown-form{
        padding: .25rem 1.5rem;
    }
    .input-group-separator{
        padding: 0.5em;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .btn-control-options{
        background-color: #eaecf4;
    }
    .gjs-mdl-card{
        background-color: #463a3c !important;
    }
</style>